import { Controller } from "@hotwired/stimulus"

// one multiple file input shown as a list of files, each with its own remove; "add another"
// reopens the picker and appends. the input's FileList is rebuilt with a DataTransfer so the
// form still posts a plain files[] array. rows rendered by the server (files kept from a
// rejected submit) carry a hidden signed id and are removed along with it
export default class extends Controller {
  static targets = ["input", "list", "template", "empty", "more"]

  connect() {
    this.files = []
    this.render()
  }

  pick() {
    this.inputTarget.click()
  }

  add(event) {
    Array.from(event.target.files).forEach((file) => {
      const duplicate = this.files.some((f) => f.name === file.name && f.size === file.size)
      if (!duplicate) this.files.push(file)
    })
    this.sync()
    this.render()
  }

  remove(event) {
    const row = event.currentTarget.closest("[data-file-list-row]")
    const index = row.dataset.fileListIndex
    if (index !== undefined) {
      this.files.splice(Number(index), 1)
      this.sync()
    }
    row.remove()
    this.render()
  }

  // put the surviving File objects back on the input
  sync() {
    const transfer = new DataTransfer()
    this.files.forEach((file) => transfer.items.add(file))
    this.inputTarget.files = transfer.files
  }

  render() {
    this.listTarget.querySelectorAll("[data-file-list-index]").forEach((row) => row.remove())
    this.files.forEach((file, index) => {
      const row = this.templateTarget.content.firstElementChild.cloneNode(true)
      row.dataset.fileListIndex = index
      row.querySelector("[data-file-list-name]").textContent = file.name
      this.listTarget.appendChild(row)
    })
    const any = this.listTarget.querySelector("[data-file-list-row]") !== null
    // .button sets display, which beats the hidden attribute
    if (this.hasEmptyTarget) this.emptyTarget.style.display = any ? "none" : ""
    if (this.hasMoreTarget) this.moreTarget.style.display = any ? "" : "none"
  }
}
